import { api } from "./api";

/**
 * Geo-waitlist position (M11-C2, plan 317). Field names mirror the Go JSON tags
 * on `waitlist.Position` (`backend/internal/services/marketplace/waitlist/types.go`),
 * surfaced by `GET /api/marketplace/waitlist`.
 *
 * WHITELIST model: a buyer is on the waitlist whenever their target area is not a
 * launched (active) metro. `count` is how many buyers want that area (the demand
 * signal). A numeric rank is present only once `count >= reveal_threshold`
 * (`revealed`); below it the card shows the "help unlock {area}" state.
 * `per_referral_boost` drives the "~N spots" copy from the same config the
 * backend reorders on (drift delta 5).
 */
export interface WaitlistPosition {
  area_key: string;
  area_label: string;
  count: number;
  reveal_threshold: number;
  revealed: boolean;
  position?: number;
  ahead?: number;
  behind?: number;
  referral_credits: number;
  per_referral_boost: number;
}

export async function getWaitlist(
  getToken: () => Promise<string | null>,
): Promise<WaitlistPosition | null> {
  const token = await getToken();
  const result = await api.get<{ waitlist: WaitlistPosition | null }>(
    "/api/marketplace/waitlist",
    token ?? undefined,
  );
  return result.waitlist;
}

/** Explicitly raise your hand for your area (no published passport required). */
export async function joinWaitlist(
  getToken: () => Promise<string | null>,
): Promise<boolean> {
  const token = await getToken();
  const result = await api.post<{ joined: boolean }>(
    "/api/marketplace/waitlist/join",
    {},
    token ?? undefined,
  );
  return result.joined;
}

/** Leave the waitlist. */
export async function leaveWaitlist(
  getToken: () => Promise<string | null>,
): Promise<void> {
  const token = await getToken();
  await api.delete("/api/marketplace/waitlist", token ?? undefined);
}
